export function NOOP() {}

export function preventEventBubbling(event) {
  event.stopPropagation();
}
